import { Box, Typography } from "@mui/material";
import MainLayout from "../components/MainLayout.js";

export default function Configuracoes() {
  return (
    <MainLayout>
      <Box>
        <Typography>Hello Word!</Typography>
        <Typography>Configurações</Typography>
      </Box>
    </MainLayout>
  );
}
